import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/loading/style/css';
import "core-js/modules/es.array.push.js";
import { ElMessage, ElMessageBox } from 'element-plus';
export default {
  data() {
    return {
      // useremail:'',
      mainstyle: '',
      showaside: true,
      showmessagenoticedialog: false,
      //通知弹出框
      useremail: 'user@disney.com',
      msglist: [],
      asidestyle: "margin:0;padding:0;width:200px;height:100%;border-right:1px solid gray;",
      hideasidestyle: {
        aside: "margin:0;padding:0;width:50px;height:100%;border-right:1px solid gray;"
      },
      asidemainstyle: "margin:0;padding:0;",
      messagenoticeparams: {
        selectedtag: 0,
        unread_count: 0,
        unread_messagelist: [],
        messagelist: [
          // {
          //     'NoticeNo': '3213213',
          //     'Title': '测试标题1',
          //     'Content': '这是测试标题一，这是第一个测试数据dfysadkuhasjdasjddgewdgeb',
          //     'SendTime': '2022-03-04 12:11:10',
          //     'ReadStatus':0,
          // },
          // {
          //     'NoticeNo': '3213213',
          //     'Title': '测试标题2',
          //     'Content': '这是测试标题二，这是第二个测试数据',
          //     'SendTime': '2022-03-04 12:11:10',
          //     'ReadStatus':0,
          // },
          // {
          //     'NoticeNo': '3213213',
          //     'Title': '测试标题3',
          //     'Content': '这是测试标题三，这是第一个测试数据',
          //     'SendTime': '2022-03-04 12:11:10',
          //     'ReadStatus':0,
          // },
        ]
      },
      messageIntervalreturndata: '',
      //定时刷新消息返回值
      ishandlemessage: false,
      //是否在处理消息
      main_body_list: [],
      origin_main_body_list: [],
      isRouterAlive: false,
      params: {
        size: 20,
        total: 0,
        page: 1
      }
    };
  },
  methods: {
    //获取基础tabs数据
    getbasetagsdata() {
      if (Object.keys(this.$store.state.basetagslist).length == 0) {
        this.$store.commit('setBasetagslist', {
          'home': {
            label: '首页',
            location: '首页'
          }
        });
        this.$store.commit('setBaseselectedtag', 'home');
      }
    },
    //获取通知消息
    getmessagedata() {
      if (this.ishandlemessage) {
        return;
      }
      if (this.messagenoticeparams.selectedtag == 0) {
        this.axios.post('notice/get/unread', {
          pageItemIndex: this.params.page,
          pageSize: this.params.size
        }).then(response => {
          if (response.data.code == 0) {
            this.messagenoticeparams.messagelist = response.data.data;
            this.messagenoticeparams.unread_messagelist = response.data.data;
            this.messagenoticeparams.unread_count = response.data.totalCount;
            this.params.total = response.data.totalCount;
          }
        }).catch(response => {
          // console.log(response);
        });
      } else if (this.messagenoticeparams.selectedtag == 1) {
        this.axios.post('notice/get/all', {
          pageItemIndex: this.params.page,
          pageSize: this.params.size
        }).then(response => {
          if (response.data.code == 0) {
            let un_list = [];
            this.messagenoticeparams.messagelist = response.data.data;
            for (var i = 0; i < response.data.data.length; i++) {
              let item = response.data.data[i];
              if (item.IsRead === 0) {
                un_list.push(item);
              }
            }
            this.messagenoticeparams.unread_messagelist = un_list;
            this.params.total = response.data.totalCount;
          }
        }).catch(response => {
          // console.log(response);
        });
      }
    },
    //左侧菜单切换页面
    changepage(child, menu) {
      // if(child.link){
      //     this.$router.push({name:child.link})
      // }
      this.$store.commit('setLocationnow', menu.Display + '/' + child.Display);
      this.$store.commit('setCurrentPermission', child.Id);
      if (!(child.PgCode in this.$store.state.basetagslist)) {
        var basetagslist = this.$store.state.basetagslist;
        if (Object.keys(this.$store.state.basetagslist).length >= 4) {
          delete basetagslist[Object.keys(basetagslist)[1]];
        }
        basetagslist[child.PgCode] = {
          label: child.Display,
          location: menu.Display + '/' + child.Display,
          permission: child.Id
        };
        this.$store.commit('setBasetagslist', basetagslist);
      }
      this.$store.commit('setBaseselectedtag', child.PgCode);
    },
    //通知弹出框 切换未读、全部
    messagenoticechangetag(selectedtag) {
      this.messagenoticeparams.selectedtag = selectedtag;
      this.getmessagedata();
    },
    messagenoticechangetag_auto() {
      this.messagenoticechangetag(this.messagenoticeparams.selectedtag);
    },
    //通知弹出框 全部标为已读
    messagenoticereadallmessage() {
      this.ishandlemessage = true;
      this.axios.post('notice/read/all', {
        data: {}
      }).then(response => {
        //后台处理已读消息逻辑完成
        this.ishandlemessage = false;
        this.getmessagedata();
      }).catch(response => {
        // console.log(response);
      });
    },
    //通知弹出框 单个点击已读
    messagenoticereadsinglemessage(item) {
      this.ishandlemessage = true;
      this.axios.post('notice/read/one', {
        data: {
          NoticeId: item.Id
        }
      }).then(response => {
        //后台处理已读消息逻辑完成
        this.ishandlemessage = false;
        this.getmessagedata();
      }).catch(response => {
        // console.log(response);
      });
    },
    //标签点击事件
    singletagclick(selecttag) {
      if (this.$store.state.baseselectedtag != selecttag) {
        this.$store.commit('setBaseselectedtag', selecttag);
        this.$router.push({
          name: selecttag
        });
        this.$store.commit('setLocationnow', this.$store.state.basetagslist[selecttag]['location']);
        this.$store.commit('setCurrentPermission', this.$store.state.basetagslist[selecttag]['permission']);
      }
    },
    //标签删除事件
    singletagdelete(deletetag) {
      var basetagslist = this.$store.state.basetagslist;
      delete basetagslist[deletetag];
      this.$store.commit('setBasetagslist', basetagslist);
      if (this.$store.state.baseselectedtag == deletetag) {
        var baseselectedtag = Object.keys(this.$store.state.basetagslist)[Object.keys(this.$store.state.basetagslist).length - 1];
        this.$store.commit('setBaseselectedtag', baseselectedtag);
        this.$router.push({
          name: baseselectedtag
        });
        this.$store.commit('setLocationnow', this.$store.state.basetagslist[this.$store.state.baseselectedtag]['location']);
      }
    },
    //登出
    logout() {
      this.axios.post('disney/current/logout', {
        Token: this.$store.state.logged_in,
        UserId: this.$store.state.current_user ? this.$store.state.current_user.Id : ''
      }).then(response => {
        this.$router.push({
          name: "login"
        });
        this.$store.commit('setLocationnow', '');
        this.$store.commit('setBasetagslist', {});
        this.$store.commit('setBaseselectedtag', '');
        this.$store.commit('setMenuclicknow', '');
        this.$store.commit('setLoggedIn', '');
        localStorage.removeItem('PageSearchState_Fpjlcx');
        localStorage.removeItem('PageSearchState_Hczfsqcl');
        localStorage.removeItem('PageSearchState_Yjcksqcl');
        localStorage.removeItem('PageSearchState_Fprecordcount');
        localStorage.removeItem('PageSearchState_Searchearlywarn');
        localStorage.removeItem('PageSearchState_Searchlog');
        localStorage.removeItem('PageSearchState_Setearlywarn');
        localStorage.removeItem('PageSearchState_Systeminteraction');
        localStorage.removeItem('PageSearchState_Userman');
        localStorage.removeItem('PageSearchState_Roleandper');
        location.href = 'https://login.myid.disney.com/logout';
      }).catch(response => {
        this.$router.push({
          name: "login"
        });
        this.$store.commit('setLocationnow', '');
        this.$store.commit('setBasetagslist', {});
        this.$store.commit('setBaseselectedtag', '');
        this.$store.commit('setMenuclicknow', '');
        this.$store.commit('setLoggedIn', '');
        localStorage.removeItem('PageSearchState_Fpjlcx');
        localStorage.removeItem('PageSearchState_Hczfsqcl');
        localStorage.removeItem('PageSearchState_Yjcksqcl');
        localStorage.removeItem('PageSearchState_Fprecordcount');
        localStorage.removeItem('PageSearchState_Searchearlywarn');
        localStorage.removeItem('PageSearchState_Searchlog');
        localStorage.removeItem('PageSearchState_Setearlywarn');
        localStorage.removeItem('PageSearchState_Systeminteraction');
        localStorage.removeItem('PageSearchState_Userman');
        localStorage.removeItem('PageSearchState_Roleandper');
        location.href = 'https://login.myid.disney.com/logout';
      });
    },
    //登出按钮
    logout_button() {
      ElMessageBox.confirm('退出登录后，当前操作将清除，确定是否退出?').then(() => {
        this.axios.post('disney/current/logout', {
          Token: this.$store.state.logged_in,
          UserId: this.$store.state.current_user ? this.$store.state.current_user.Id : ''
          // Active: '1',
        }).then(response => {
          this.$router.push({
            name: "login"
          });
          this.$store.commit('setLocationnow', '');
          this.$store.commit('setBasetagslist', {});
          this.$store.commit('setBaseselectedtag', '');
          this.$store.commit('setMenuclicknow', '');
          this.$store.commit('setLoggedIn', '');
          localStorage.removeItem('PageSearchState_Fpjlcx');
          localStorage.removeItem('PageSearchState_Hczfsqcl');
          localStorage.removeItem('PageSearchState_Yjcksqcl');
          localStorage.removeItem('PageSearchState_Fprecordcount');
          localStorage.removeItem('PageSearchState_Searchearlywarn');
          localStorage.removeItem('PageSearchState_Searchlog');
          localStorage.removeItem('PageSearchState_Setearlywarn');
          localStorage.removeItem('PageSearchState_Systeminteraction');
          localStorage.removeItem('PageSearchState_Userman');
          localStorage.removeItem('PageSearchState_Roleandper');
          location.href = 'https://login.myid.disney.com/logout';
        }).catch(response => {
          this.$router.push({
            name: "login"
          });
          this.$store.commit('setLocationnow', '');
          this.$store.commit('setBasetagslist', {});
          this.$store.commit('setBaseselectedtag', '');
          this.$store.commit('setMenuclicknow', '');
          this.$store.commit('setLoggedIn', '');
          localStorage.removeItem('PageSearchState_Fpjlcx');
          localStorage.removeItem('PageSearchState_Hczfsqcl');
          localStorage.removeItem('PageSearchState_Yjcksqcl');
          localStorage.removeItem('PageSearchState_Fprecordcount');
          localStorage.removeItem('PageSearchState_Searchearlywarn');
          localStorage.removeItem('PageSearchState_Searchlog');
          localStorage.removeItem('PageSearchState_Setearlywarn');
          localStorage.removeItem('PageSearchState_Systeminteraction');
          localStorage.removeItem('PageSearchState_Userman');
          localStorage.removeItem('PageSearchState_Roleandper');
          location.href = 'https://login.myid.disney.com/logout';
        });
      }).catch(() => {});
    },
    //检查用户是否长时间未操作
    checkoperation() {
      var timenow = new Date();
      var that = this;
      if ((timenow.getTime() - that.$store.state.operationtime) / 1000 >= 60 * 30) {
        // ElMessage({
        //     message:'账号登录已过期，请重新登录',
        //     type:'info'
        // })
        // that.logout()
        // document.body.onmousedown=undefined
        document.body.onmousedown = function () {
          ElMessage({
            message: '账号登录已过期，请重新登录',
            type: 'info'
          });
          that.logout();
          document.body.onmousedown = undefined;
        };
        clearInterval(this.$store.state.intervalid);
      }
    },
    //跳转至首页
    jumptohome() {
      this.$router.push({
        name: "home"
      });
      this.$store.commit('setLocationnow', '首页');
      this.$store.commit('setBaseselectedtag', 'home');
      if (this.$route.name == 'home') {
        this.routerreload();
      }
    },
    //设置窗口自适应
    basesetwindowselfadaption() {
      var asidemenutitle = document.getElementById('asidemenutitle');
      this.asidemainstyle = "margin:0;padding:0;height:" + (document.documentElement.clientHeight - asidemenutitle.clientHeight) + "px";
    },
    // 刷新到首页
    reloadToHome() {
      window.loading = ElLoading.service({
        lock: true,
        text: '处理中……',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.jumptohome();
      var basetagslist = this.$store.state.basetagslist;
      var dlist = [];
      for (var i in basetagslist) {
        if (i == 'home') continue;
        dlist.push(i);
      }
      for (var i = 0; i < dlist.length; i++) {
        this.singletagdelete(dlist[i]);
      }
      window.loading.close();
    },
    // 获取主体
    getMainBody() {
      this.axios.post('disney/user/main_body').then(response => {
        if (response.data.code == 0) {
          this.origin_main_body_list = response.data.data;
          this.$store.commit('setMainBodyList', response.data.data);
        }
        this.currentMainBody();
      }).catch(response => {
        // console.log(response);
      });
    },
    // 切换到主体
    changeMainBody(tax_nr, name) {
      window.loading = ElLoading.service({
        lock: true,
        text: '处理中……',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (tax_nr == this.$store.state.main_body_id) return;
      ElMessageBox.confirm('切换主体后，当前操作将清除，确定是否切换？').then(() => {
        ElMessage({
          message: '切换到 ' + name,
          type: 'info'
        });
        this.$store.commit('setMainBodyId', tax_nr);
        this.$store.commit('setUsername', name);
        this.reloadToHome();
      }).catch(() => {
        window.loading.close();
      });
    },
    // 获取当前用户信息
    currentUser() {
      this.axios.post('disney/current').then(response => {
        if (response.data.code == 0) {
          this.$store.commit('setCurrentUser', response.data.data);
        }
        this.currentMainBody();
      }).catch(response => {
        // console.log(response);
      });
    },
    // 获取当前主体信息
    currentMainBody() {
      var user_main_body_list = this.$store.state.current_user.InMainBody;
      var result_list = [];
      var flagInited = true;
      for (var i = 0; i < this.origin_main_body_list.length; i++) {
        for (var j = 0; j < user_main_body_list.length; j++) {
          if (this.origin_main_body_list[i].SellerTaxNumber == user_main_body_list[j]) {
            result_list.push({
              SellerTaxNumber: this.origin_main_body_list[i].SellerTaxNumber,
              SellerName: this.origin_main_body_list[i].SellerName
            });
          }
        }
      }
      this.main_body_list = result_list;
      if (flagInited) {
        if (!!this.$store.state.main_body_id) {
          var flagCanContinueUseId = false;
          for (var i = 0; i < this.main_body_list.length; i++) {
            if (this.main_body_list[i].SellerTaxNumber == this.$store.state.main_body_id) {
              flagCanContinueUseId = true;
            }
          }
          if (flagCanContinueUseId) {
            this.isRouterAlive = true;
            return;
          }
        }
        if (this.main_body_list.length > 0) {
          this.$store.commit('setMainBodyId', this.main_body_list[0].SellerTaxNumber);
          this.$store.commit('setUsername', this.main_body_list[0].SellerName);
          this.isRouterAlive = true;
        }
      } else {
        this.isRouterAlive = true;
      }
    },
    // 获取当前菜单
    getCurrentMenu() {
      this.$http.post('disney/current/menu', {}).then(response => {
        if (response.data.code == 0) {
          this.$store.commit('setMenulist', response.data.data[0].Children);
          // console.log(response.data.data[0].Children)
        }
      }).catch(response => {
        // console.log(response);
      });
    },
    // routerview页面刷新
    routerreload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  mounted() {
    var loading = ElLoading.service({
      lock: true,
      text: '正在获取发票信息……',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    setTimeout(function () {
      loading.close();
    });
    this.currentUser();
    this.getCurrentMenu();
    this.getbasetagsdata();
    this.getmessagedata();
    this.getMainBody();
    var that = this;
    var newtime = new Date();
    that.$store.commit('setOperationtime', newtime.getTime());
    document.body.onmousedown = function () {
      var newtime = new Date();
      that.$store.commit('setOperationtime', newtime.getTime());
    };
    this.$store.commit('setIntervalid', parseInt(setInterval(this.checkoperation, 500)));
    this.basesetwindowselfadaption();
    window.addEventListener("resize", this.basesetwindowselfadaption);

    //每隔2分钟自动刷新消息
    // this.messageIntervalreturndata=setInterval(this.getmessagedata,1000*5)
  },

  unmounted() {
    window.removeEventListener("resize", this.basesetwindowselfadaption);
    if (this.messageIntervalreturndata) {
      clearInterval(this.messageIntervalreturndata);
    }
  }
};